import React, { ReactNode } from "react";

interface ModalProps {
  isOpen: boolean;
  children: ReactNode;
  className?: string;
}

const Modal: React.FC<ModalProps> = ({ isOpen, children, className = "" }) =>
  isOpen ? (
    <div className={`modal-base ${className}`}>
      <div className="modal-content">{children}</div>
    </div>
  ) : null;

export default Modal;
